import { Card } from "@/components/ui/card";

const Bar = ({ className }) => <div className={`bg-md3-surface-container-high rounded-md3-sm animate-pulse ${className}`} />;

export const MetricCardsSkeleton = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8" data-testid="sales-metrics-skeleton">
    {[0, 1, 2].map((i) => (
      <Card key={i} className="p-6 border-0 shadow-md3-1 rounded-md3-lg space-y-3">
        <Bar className="h-4 w-24" />
        <Bar className="h-8 w-40" />
        <Bar className="h-3 w-16" />
      </Card>
    ))}
  </div>
);

export const TableSkeleton = ({ rows = 5, testId }) => (
  <div className="space-y-3" data-testid={testId}>
    <Bar className="h-5 w-full" />
    {Array.from({ length: rows }, (_, i) => <Bar key={i} className="h-10 w-full" />)}
  </div>
);

export const CardSkeleton = ({ title, rows, testId, className = "" }) => (
  <Card className={`p-6 mb-6 border-0 shadow-md3-2 rounded-md3-lg ${className}`} data-testid={testId}>
    <h2 className="text-md3-title-large text-md3-on-surface mb-4">{title}</h2>
    <TableSkeleton rows={rows} />
  </Card>
);
